import type { UploadFile } from 'antd/es/upload/interface';
import type { FormInstance } from 'antd/es/form';
import { message as antdMessage } from 'antd';

import { buildFormData } from 'utils/buildFormData';
import { validateAndAppendFiles } from 'utils/validateAndAppendFiles';
import { api } from 'utils/api';
import { sleep } from 'utils/sleep';
import type { FormFields } from 'interfaces/preliminary-application.interface';

interface SubmitRequestParams {
    url: string;
    payload: Record<string, any>;
    fileList: UploadFile[];
    form: FormInstance;
    resetStates: (fields?: FormFields, formInstance?: FormInstance) => void;
    loaderDelay?: number;
    headers?: Record<string, string>;
}

export const submitPreliminaryApplicationRequest = async ({
    url,
    payload,
    fileList,
    form,
    resetStates,
    loaderDelay = 2000,
    headers,
}: SubmitRequestParams) => {
    const formData = buildFormData(payload, 'files');

    await validateAndAppendFiles({
        fileList,
        formData,
        form,
        resetStates,
        message: antdMessage,
        sleep,
        LOADER_DELAY_IN_MS: loaderDelay,
    });

    const response = await api.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            ...headers,
        },
    });

    return response.data?.data;
};
